// Module
var code = `<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="conversion_rate.ConversionRateByPurchaseChart"></bfg-chart>
    </div>
</div>

<div class="row">
	<table class="table">
		<tr>
			<th>Date</th>
			<th>Installs</th>
			<th>Purchase 1</th>
			<th>Purchase 2</th>
			<th>Purchase 3</th>
		</tr>
		<tr ng-repeat="day in purchases_data">
        <td><a ui-sref="amt.ww2.life_time.players_purchases({'date': day.date})" target="_blank">{{day.date}}</a></td>
		    <td>{{day.installs}}</td>
		    <td ng-style="{'background-color': apply_purchase_color(day.percents1, 'percents1')}">
                {{apply_purchase_value(day.percents1)}}
            </td>
		    <td ng-style="{'background-color': apply_purchase_color(day.percents2, 'percents2')}">
                {{apply_purchase_value(day.percents2)}}
            </td>
		    <td ng-style="{'background-color': apply_purchase_color(day.percents3, 'percents3')}">
                {{apply_purchase_value(day.percents3)}}
            </td>
		</tr>
	</table>
</div>
`;
// Exports
module.exports = code;